var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-badge',{attrs:{"left":"","color":"red"},model:{value:(_vm.shouldShow),callback:function ($$v) {_vm.shouldShow=$$v},expression:"shouldShow"}},[_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.itemCount))])])}
var staticRenderFns = []

export { render, staticRenderFns }